import React from "react";

export default function renderIcon({
  width = 34,
  height = 34,
  color = "#22a227",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g id="Group_1000" data-name="Group 1000" transform="translate(-28 -635)">
        <circle
          id="Ellipse_3786"
          data-name="Ellipse 3786"
          cx="17"
          cy="17"
          r="17"
          transform="translate(28 635)"
          fill={color}
        />
        <line
          id="Line_426"
          data-name="Line 426"
          x2="8"
          y2="7"
          transform="translate(35.5 652.5)"
          fill="none"
          stroke="#fff"
          stroke-width="3"
        />
        <line
          id="Line_427"
          data-name="Line 427"
          x1="13"
          y2="15"
          transform="translate(41.5 644.5)"
          fill="none"
          stroke="#fff"
          stroke-width="3"
        />
      </g>
    </svg>
  );
}
